(() => {
  if (window.lockinTechnologyShopBound) return;
  window.lockinTechnologyShopBound = true;
  document.addEventListener('change', event => {
    const select = event.target.closest('[data-tech-variant]');
    if (!select) return;
    const form = select.closest('form');
    const option = select.selectedOptions[0];
    const available = option.dataset.available === 'true';
    form.querySelector('[data-tech-price]').textContent = option.dataset.price;
    const submit = form.querySelector('[data-tech-submit]');
    submit.disabled = !available;
    submit.textContent = available ? 'Add to cart' : 'Sold out';
    const card = form.closest('.lk-tech-product');
    const img = card.querySelector('.lk-tech-product-image img');
    if (img && option.dataset.image) {
      img.removeAttribute('srcset');
      img.src = option.dataset.image;
      img.alt = option.dataset.title;
    }
    const details = card.querySelector('[data-tech-details]');
    if (details) {
      const url = new URL(details.href);
      url.searchParams.set('variant', select.value);
      details.href = url.toString();
    }
  });
})();
